var r = /* @__PURE__ */ ((L) => (L[L.PURPLE = 0] = "PURPLE", L[L.EXPEDITION_PURPLE = 1] = "EXPEDITION_PURPLE", L[L.BLACK = 2] = "BLACK", L))(r || {});
export {
  r as INFO_POPUP_TYPE
};
//# sourceMappingURL=popup.js.map
